// Optimize Supabase storage image URLs via the render/image transform endpoint.
// Falls back to original URL for non-Supabase images.
export function optimizedImage(url: string | null | undefined, width: number, quality = 75): string {
  if (!url) return "";
  if (!url.includes("/storage/v1/object/public/")) return url;
  const transformed = url.replace("/storage/v1/object/public/", "/storage/v1/render/image/public/");
  const sep = transformed.includes("?") ? "&" : "?";
  return `${transformed}${sep}width=${width}&quality=${quality}&resize=contain`;
}
